import createWrongAddressTypeValidator from '@exodus/send-validation/src/validations/createWrongAddressTypeValidator';

export const ADDRESS_TYPE_VALIDATION = createWrongAddressTypeValidator({
  shouldValidate: ({ asset }) => ['solana'].includes(asset.name),
  getMessage: () => 'Address has an invalid type.',
});
